import reqest from "../common/reqest";

/**
 * 获取首页顶部背景图片
 * @param {*} url 
 * @param {*} param 
 */
export function getIndexTopImg(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 首页banner
 * @param {*} url 
 * @param {*} param 
 */
export function getBanner(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 获取展会信息
 * @param {*} url 
 * @param {*} param 
 */
export function getExhibitionInfo(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 观展人员进入直播间
 * @param {*} url 
 * @param {*} param 
 */
export function visitorsEnterLiveRoom(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 获取预约时间
 * @param {*} url 
 * @param {*} param 
 */
export function exhTime(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 展会简介
 * @param {*} url 
 * @param {*} param 
 */
export function exhibitionIntroduc(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 展会简介
 * @param {*} url 
 * @param {*} param 
 */
export function getLiveRoom(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 获取展会下的展商
 * @param {*} url 
 * @param {*} param 
 */
export function getCompanys(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 直播推介
 * @param {*} url 
 * @param {*} param 
 */
export function broadcast(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 来宾
 * @param {*} url 
 * @param {*} param 
 */
export function guest(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 获取当前展商在当前展会下得所有直播间
 * @param {*} url 
 * @param {*} param 
 */
export function getAllLiveRoom(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 获取展会介绍信息
 * @param {*} url 
 * @param {*} param 
 */
export function getExhibitionChannelInfo(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 获取展会名称的下拉菜单
 * @param {*} url 
 * @param {*} param 
 */
export function getExhibitionNameMenu(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 参展商进入直播间
 * @param {*} url 
 * @param {*} param 
 */
export function exhibitionEnterLiveRoom(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 当前用户在展会下的直接间
 * @param {*} url 
 * @param {*} param 
 */
export function getUserLiveRoom(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 获取所有展会
 * @param {*} url 
 * @param {*} param 
 */
export function getAllExhibition(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 获取直播列表
 * @param {*} url 
 * @param {*} param 
 */
export function subscribeList(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 公告列表
 * @param {*} url 
 * @param {*} param 
 */
export function noticeList(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 获取展会id
 * @param {*} url 
 * @param {*} param 
 */
export function getExhibitionId(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 获取席位列表
 * @param {*} url 
 * @param {*} param 
 */
export function getSeatsList(url, param) {
  return reqest.getRequest(url, param)
}

/**
 * 预约展会
 * @param {*} url 
 * @param {*} param 
 */
export function bookingExhibition(url, param) {
  return reqest.postRequest(url, param)
}

/**
 * 同意预约
 * @param {*} url 
 * @param {*} param 
 */
export function agreeAppointment(url, param) {
  return reqest.putRequest(url, param)
}

/**
 * 取消预约
 * @param {*} url 
 * @param {*} param 
 */
export function cancelAppointment(url, param) {
  return reqest.putRequest(url, param)
}

/**
 * 取消预约
 * @param {*} url 
 * @param {*} param 
 */
export function cancelReservation(url, param) {
  return reqest.deleteRequest(url, param)
}


